export default [
  {
    path: "/shop/authenticate/company",
    name: "AuthCompany",
    meta: {
      title: "企业资质认证",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/shop/authenticate/Company.vue")
  },
  {
    path: "/shop/authenticate/patient",
    name: "AuthPatient",
    meta: {
      title: "病人资质认证",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/shop/authenticate/Patient.vue")
  }
];
